import { makeDataObjGenerator } from 'mocks/helpers'
import { createGqlResponseTransformer } from 'utils/test-utils'

const defaultItem = {
  id: '624cf0360632e7ff35e1cea8',
  nativeGivenName: 'TestGivenName',
  nativeFamilyName: 'TestFamilyName',
  nationalityCode: 'USA',
  sex: 'M',
  age: 57,
  birthYear: 1965,
  addresses: [],
  biographicalInformation: null,
  worldTennisNumbers: [],
  __typename: 'Person',
}

export const createSuggestion = makeDataObjGenerator(defaultItem)

const defaultData = {
  items: [
    { id: '1', nativeGivenName: 'TestGivenName1', nativeFamilyName: 'TestFamilyName1' },
    { id: '2', nativeGivenName: 'TestGivenName2', nativeFamilyName: 'TestFamilyName2' },
    { id: '3', nativeGivenName: 'TestGivenName3', nativeFamilyName: 'TestFamilyName3' },
    { id: '4', nativeGivenName: 'TestGivenName4', nativeFamilyName: 'TestFamilyName4' },
    { id: '5', nativeGivenName: 'TestGivenName5', nativeFamilyName: 'TestFamilyName5' },
  ].map(obj => createSuggestion(obj)),
  totalItems: 5,
}

export const getSuggestions = createGqlResponseTransformer(
  'publicPersons',
  'PersonList',
  defaultData
)
